export interface CropPoint {
  x: number;
  y: number;
}

export interface CropSize {
  width: number;
  height: number;
}

export interface CropRect extends CropPoint, CropSize {}

export enum CropUnit {
  Pixels = 'pixels',
  Percentage = 'percentage',
  AspectRatio = 'aspect-ratio',
}

export enum CropOperation {
  None = 'none',
  Move = 'move',
  ResizeN = 'resize-n',
  ResizeS = 'resize-s',
  ResizeE = 'resize-e',
  ResizeW = 'resize-w',
  ResizeNE = 'resize-ne',
  ResizeNW = 'resize-nw',
  ResizeSE = 'resize-se',
  ResizeSW = 'resize-sw',
}

export interface CropOptions {
  width: number;
  height: number;
  units: CropUnit;
}

export interface CropTransformOptions {
  operation: CropOperation;
  dx: number;
  dy: number;
  aspectRatio: number;
  centerAsBase: boolean;
  imageSize: CropSize;
}

export interface CropPresentation {
  readonly borderColor: string;
  readonly borderWidth: number;
  readonly checkerboardDark: string;
  readonly checkerboardLight: string;
  readonly checkerboardSize: number;
  readonly gridColor: string;
  readonly gridWidth: number;
  readonly handleFill: string;
  readonly handleSize: number;
  readonly previewPadding: number;
  readonly shadowColor: string;
  readonly shadowOpacity: number;
}

export interface CropControllerPointerEvent {
  readonly clientX: number;
  readonly clientY: number;
  readonly pointerId: number;
  readonly ctrlKey?: boolean;
  preventDefault?(): void;
}
